import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import NewsListPage from "@/pages/news/page";
import NewsDetailPage from "@/pages/news/detail/page";
import WorksListPage from "@/pages/works/page";
import WorkDetailPage from "@/pages/works/detail/page";
import GalleryPage from "@/pages/gallery/page";
import SpecialPage from "@/pages/special/page";
import SpecialDetailPage from "@/pages/special/detail/page";
import AboutPage from "@/pages/about/page";
import SearchPage from "@/pages/search/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/news",
    element: <NewsListPage />,
  },
  {
    path: "/news/:id",
    element: <NewsDetailPage />,
  },
  {
    path: "/works",
    element: <WorksListPage />,
  },
  {
    path: "/works/:id",
    element: <WorkDetailPage />,
  },
  {
    path: "/gallery",
    element: <GalleryPage />,
  },
  {
    path: "/special",
    element: <SpecialPage />,
  },
  {
    path: "/special/:id",
    element: <SpecialDetailPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/search",
    element: <SearchPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;